import { useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import { useConfig } from '../configContext.js';
import AccountPicker from './AccountPicker.jsx';
import Modal from './Modal.jsx';

export default function AddAccount({
  startDate,
  endDate,
  setAccounts,
  setNotHideAccounts,
  setColor,
  setSnackbarOpen,
  setMessage,
  onClose,
  accounts,
}) {
  const { apiUrl } = useConfig();
  const [selected, setSelected] = useState([]);
  const [submitting, setSubmitting] = useState(false);

  const alreadyAdded = useMemo(() => new Set(accounts.map((a) => a.name)), [accounts]);

  const notify = (message, color) => {
    setMessage(message);
    setColor(color);
    setSnackbarOpen(true);
  };

  const apply = (data, response, successMessage) => {
    if (response.status !== 200) return notify(data.message, 'danger');
    setSelected([]);
    setAccounts(Object.values(data.accounts) || []);
    setNotHideAccounts(Object.values(data.not_hide_accounts) || []);
    return notify(successMessage, 'success');
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (selected.length === 0) return notify('Veuillez sélectionner un compte.', 'danger');

    setSubmitting(true);
    try {
      if (selected.length === 1) {
        const account = selected[0];
        const response = await fetch(`${apiUrl}/calendars/${account.uuid}`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ name: account.name, uuid: account.uuid, start: startDate, end: endDate }),
        });
        apply(await response.json(), response, 'Compte ajouté avec succès');
      } else {
        const response = await fetch(`${apiUrl}/calendars/multiple`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ accounts: selected, start: startDate, end: endDate }),
        });
        apply(await response.json(), response, 'Comptes ajoutés avec succès');
      }
      onClose();
    } catch (error) {
      notify(error.message, 'danger');
    } finally {
      setSubmitting(false);
    }
    return undefined;
  };

  return (
    <Modal
      title="Ajouter un compte"
      onClose={() => {
        setMessage('');
        setSnackbarOpen(false);
        onClose();
      }}
      width="max-w-3xl"
    >
      <form onSubmit={handleSubmit}>
        <AccountPicker
          value={selected}
          onChange={setSelected}
          placeholder="Rechercher et sélectionner un compte"
          disabledNames={alreadyAdded}
          disabledLabel="Calendrier déjà ajouté"
          autoFocus
        />
        <button
          type="submit"
          disabled={selected.length === 0 || submitting}
          className="mt-4 rounded-md bg-brand-500 px-3 py-1.5 text-sm font-medium text-white hover:bg-brand-600 disabled:opacity-50"
        >
          Ajouter
        </button>
      </form>
    </Modal>
  );
}

AddAccount.propTypes = {
  startDate: PropTypes.string,
  endDate: PropTypes.string,
  setAccounts: PropTypes.func.isRequired,
  setNotHideAccounts: PropTypes.func.isRequired,
  setColor: PropTypes.func.isRequired,
  setSnackbarOpen: PropTypes.func.isRequired,
  setMessage: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  accounts: PropTypes.array.isRequired,
};
